import { NgModule } from '@angular/core';
import {AppComponent } from '../app.component';
import { CommonModule } from '@angular/common';
import { PeticionesRoutingModule } from './peticiones-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PeticionesComponent } from './peticiones.component';
import {MatButtonModule} from '@angular/material/button';
import { MatDialogModule} from '@angular/material/dialog';
import { MatInputModule} from '@angular/material/input';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatProgressSpinnerModule, MatSpinner} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import {MatCardModule} from "@angular/material/card";
import {MatSort, MatSortModule} from "@angular/material/sort";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {MatToolbarModule} from "@angular/material/toolbar";
import {DetallePeticionComponent} from "./detalle_peticion/detalle_peticion.component";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatListModule} from "@angular/material/list";
import {ReclamacionesOverlay} from "./reclamacion_overlay/reclamacion_overlay.component";
import {AlertDialogComponent} from "./alert-dialog/alert-dialog.component";
import {DetalleDevolucionComponent} from "./detalle_devolucion/detalle_devolucion.component";

registerLocaleData(localeEs);
@NgModule({
  declarations:
  [
    PeticionesComponent,
    DetallePeticionComponent,
    ReclamacionesOverlay,
    AlertDialogComponent,
    DetalleDevolucionComponent
  ],
  imports: [
    CommonModule,
    PeticionesRoutingModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule,
    MatToolbarModule,
    MatGridListModule,
    MatListModule

  ],
  providers:[],

  bootstrap:[AppComponent]
})
export class PeticionesModule { }
